'use strict';

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _cookie = require('../utils/cookie');

var _cookie2 = _interopRequireDefault(_cookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *  When clicked on element with 'data-cookie' attribute,
 *  cookie value is set to the value specified by the element.
 *
 *  if data-cookie-value is present, its value is used, otherwise
 *  jQuery.fn.val is used instead.
 *
 *  Example:
 *  <button type="button" data-cookie="myCookie" data-cookie-value="myValue">Click me!</button>
 *  will set the cookie with name "myCookie" to value "myValue".
 */
(0, _jquery2.default)(document).on('click', '[data-cookie]', function () {
  var $this = (0, _jquery2.default)(this);
  var cookieName = $this.attr('data-cookie');
  var cookieValue = $this.attr('data-cookie-value') || $this.val();
  _cookie2.default.setCookie(cookieName, cookieValue);
});


//////////////////
// WEBPACK FOOTER
// ./~/linksoft/initializers/cookie-value.js
// module id = 997
// module chunks = 0